export default __webpack_public_path__ + "bdaee608858432a0f1b019965d38195c.svg";